module.exports = {
	EN: 'en',
}
